import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";

const OutletLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  return (
    <div className="d-flex flex-column vh-100">
      <Header onToggleSidebar={toggleSidebar} />
      <div className="d-flex flex-grow-1" style={{ marginTop: "64px" }}>
        <Sidebar open={sidebarOpen} onClose={toggleSidebar} />
        <main className="flex-grow-1 p-3 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default OutletLayout;
